import { addLog } from './addLog.js';

// 全局错误处理函数
function handleError(error = {}, errorInfo = '', source = 'unknown') {
  const errorMessage = {
    message: error?.message || '未知错误',
    stack: error?.stack || '',
    source: source,
    timestamp: new Date().toISOString(),
    url: window.location.href,
    userAgent: navigator.userAgent,
    errorInfo: errorInfo
  }
  // 如果是$notify.error，不上报
  if (errorMessage.message?.includes('$notify.error')) {
    return;
  }
  addLog('error', '捕获报错', errorMessage);
  console.warn('🚨 全局错误捕获 global catch error:', errorMessage)
}

function catchErr(Vue) {
  // Vue 全局错误处理
  Vue.config.errorHandler = function (err, vm, info) {
    const componentName = vm && vm.$options.name ? vm.$options.name : '未知组件'
    const errorInfo = `Vue组件错误 - 组件: ${componentName}, 错误信息: ${info}`
    handleError(err, errorInfo, 'vue-component')
  }

  // 全局未捕获的Promise错误
  window.addEventListener('unhandledrejection', function (event) {
    const error = event.reason
    handleError(error, 'Promise未捕获的拒绝', 'promise-rejection')
    // 阻止默认的控制台错误输出
    event.preventDefault()
  })

  // 全局JavaScript错误捕获
  window.addEventListener('error', function (event) {
    const error = {
      message: event?.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error ? event.error.stack : ''
    }
    handleError(error, `JavaScript运行时错误 - 文件: ${event.filename}:${event.lineno}:${event.colno}`, 'javascript-runtime')
  })

  // 资源加载错误捕获
  window.addEventListener('error', function (event) {
    if (event.target !== window) {
      const resourceError = {
        message: `资源加载失败: ${event.target.src || event.target.href}`,
        tagName: event.target.tagName,
        source: event.target.src || event.target.href
      }
      handleError(resourceError, '资源加载错误', 'resource-loading')
    }
  }, true)
}

export default catchErr;